import _isEmpty from 'lodash/isEmpty';
import { extractUsernameFromSocialMediaLink } from '../../services/social';
export function getUserName(userName, link) {
  if (!_isEmpty(userName)) {
    return userName;
  }
  if (!_isEmpty(link)) {
    return extractUsernameFromSocialMediaLink(link);
  }
  return '';
}